<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs>
        <!-- 策略权限设置 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_list18") }}</span>
          <div class="main maina-a">
            <p>
              <!-- <span class="main_text"> {{ $t("logs.Policy_list19") }}:</span>
                        <el-select v-model="defaut_pol" placeholder="请选择" style="width:12%">
                            <el-option v-for="item in defaut_pol_arr" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-button @click="save_defaut()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.save_a") }}</el-button> -->

              <el-alert
                title="选择完成后，点击保存，即可保存当前管理员的操作权限"
                type="warning"
                show-icon
                :closable="false"
              ></el-alert>
            </p>
          </div>
          <div class="switch1">
            <div class="table table_left">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                highlight-current-row
                :data="fileList1"
                
               @row-click="tableRowClassName"
                >>

                <el-table-column prop="" width="20"> </el-table-column>
                <el-table-column prop="value" :label="$t('logs.Policy_list21')">
                </el-table-column>
              </el-table>
            </div>
            <div class="table table_right">
              <div class="lie" v-if="this.policy_priv_show == 1">
                <div class="find">
                  <!-- 策略权限 -->
                  <div class="find1 table_right">
                    <div class="find-text" style="padding-right: 12px">
                      {{ $t("logs.Policy_list20") }} :
                    </div>
                    <div class="block block1" v-loading="loading">
                      <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                        style="padding: 6px 0"
                        >{{ $t("logs.report13") }}</el-checkbox
                      >

                      <el-checkbox-group
                        v-model="checkedCities"
                        @change="handleCheckedCitiesChange"
                        style="
                          display: flex;
                          flex-wrap: wrap;
                          padding-bottom: 6px;
                        "
                      >
                        <el-checkbox
                          v-for="v in policy_priv"
                          :label="v.value"
                          :key="v.value"
                          class="policy_priv_role"
                          >{{ v.value }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>

                  </div>
                    <div class="find1">
                   <div class="find-text" style="padding-right:12px">
                   
                  </div>
                  <div class="block block1">
                    <el-button type="primary" @click="save_distribution()" 
                     :disabled="$root.jurisdiction.only_query == 0">{{
                  $t("tab.save")
                }}</el-button>
               
                
                  
                  </div>
                </div>
                </div>
              </div>

             
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      admin_user:'',
      policy_priv_show: 1,
      checkAll: false,
      checkedCities: [],
      policy_priv: [],
      isIndeterminate: false,
      fileList1:[],
      loading:false,
    
    };
  },
  mounted() {
    this.getFileList_distr();
  },
  methods: {
      
    handleCheckAllChange(val) {
      console.log(val);
       
      this.checkedCities = val ? this.policy_priv.map((ele) => ele.value) : [];
        this.isIndeterminate = false;

      // this.isArr_priv();
    },

    handleCheckedCitiesChange(value) {
      console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.policy_priv.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.policy_priv.length;
      console.log( this.checkAll,this.isIndeterminate ,checkedCount,this.policy_priv.length)
      this.isArr_priv();
    },
    isArr_priv() {
      this.policy_priv.forEach((value) => {
        if (this.checkedCities.includes(value.value)) {
          value.select = 1;
        } else {
          value.select = 0;
        }
      });
      console.log(this.checkedCities, this.policy_priv);
    },
    save_distribution() {
    
        this.loading = true;

        let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      
    
        let str = this.$qs.stringify({
          __mode: "save_policy_distribution",
          sid: sid,
          admin:this.admin_user,
          rule_arr: JSON.stringify(this.checkedCities) ,
        });
        this.$axios.post("/api/adm/cgi/admin.cgi", str).then((res) => {
          console.log(res);
          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            this.getFileList_distr();
        
        
         }
         })
    },
   

    // 策略权限加载
    getFileList_distr() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/admin.cgi", {
          params: {
            __mode: "load_policy_distribution",
            sid: sid,
            admin:this.admin_user,
          },
        })
        .then((res) => {
          console.log(res);
            this.loading = false;

          if (!res) {
            alert(res.data);
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
          
            this.fileList1 = res.data.ret.all_admins;
            this.admin_user=res.data.ret.cur_admin

          for(let v=0;v< res.data.ret.all_admins.length;v++){
            if(res.data.ret.cur_admin==res.data.ret.all_admins[v].value){
            // console.log(v)
              this.$refs.multipleTable.setCurrentRow( this.fileList1[v]);
            }
          }
           
            this.fileList_role = res.data.ret.all_rules;
            this.policy_priv = res.data.ret.all_rules;
            this.checkedCities=res.data.ret.match_rules
          
            this.isIndeterminate =
        this.checkedCities.length > 0 &&   this.checkedCities.length < this.policy_priv.length;
          this.checkAll =  this.checkedCities.length === this.policy_priv.length;
           
           
          }
        });
    },
   
  // 点击每行，获取管理员
    tableRowClassName( row) {
        console.log(row)
        this.admin_user=row.value
        this.getFileList_distr()
      
    },
  },
};
</script>

<style lang="less" scoped>
// 1
.main {
  display: flex;
  align-items: center;
  border: 2px solid #d2d7e6;

  // background: #f1f1f1;
  margin: 10px;

  text-align: left;
  //   margin-top: 20px;
}

.main p {
  height: 44px;
  width: 100%;
  display: flex;
  padding-left: 10px;
  font-size: 12px;

  align-items: center;
}

.main_text {
  margin-right: 6px;

  color: #0e2c5e;
}

.main .el-input {
  margin-right: 6px;
}

.main .el-select {
  margin-right: 6px;
}

.main {
  padding: 0;
}

/deep/ .el-input__icon {
  height: 24px;
  line-height: 24px;
}

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
.table_right {
  background: #fff;
  //  height: 100%;

  // border: 1px solid #D2D7E6;
  .find {
    width: 100%;
    margin-top: 0;
    border: 0px;
    border: 2px solid #d2d7e6;
    height: 100%;
    .find1 {
      width: 100%;
    }
    .find-text {
      width: 18%;
    }
    .block {
      flex: 1;
      .el-checkbox {
        margin-right: 0;
      }
      .policy_priv_role {
        width: 20%;
      }
    }
  }
}

/deep/ .el-tabs__nav {
  padding-left: 14px;
}
.switch1 {
  display: flex;
  width: 100%;
  .table_left {
    width: 15%;
    margin-right: 0px;
    /deep/ .el-table__body tr.current-row > td {
      background-color: #c7e8f3;
    }
  }
  .table_right {
    width: calc(85% - 45px);
  }
}
/deep/ .table_right th:nth-child(2) {
  text-align: center;
}

// 表格居中位置
/deep/ .table_right .el-table__row td:nth-child(2) {
  text-align: center;
}
</style>
